import { createFileRoute, redirect } from '@tanstack/react-router';

// Live calls moved under `/calls/live`; keep old links working.
export const Route = createFileRoute('/_authenticated/live-calls')({
  beforeLoad: () => {
    throw redirect({ to: '/calls/live', replace: true });
  },
});
